// Input — keyboard + pointer-lock mouse for first-person.
export class Input {
  constructor(canvas) {
    this.canvas = canvas;
    this.keys = new Set();
    this.mouseDX = 0;
    this.mouseDY = 0;
    this.locked = false;
    window.addEventListener('keydown', e => {
      this.keys.add(e.code);
      if (e.code === 'Space' || e.code === 'Tab') e.preventDefault();
    });
    window.addEventListener('keyup', e => this.keys.delete(e.code));
    canvas.addEventListener('click', () => {
      if (!this.locked) canvas.requestPointerLock();
    });
    document.addEventListener('pointerlockchange', () => {
      this.locked = document.pointerLockElement === canvas;
    });
    document.addEventListener('mousemove', (e) => {
      if (!this.locked) return;
      this.mouseDX += e.movementX;
      this.mouseDY += e.movementY;
    });
  }
  read() {
    const k = this.keys;
    const fw = (k.has('KeyW') ? 1 : 0) + (k.has('KeyS') ? -1 : 0);
    const rt = (k.has('KeyD') ? 1 : 0) + (k.has('KeyA') ? -1 : 0);
    const out = {
      forward: fw, right: rt,
      sprint: k.has('ShiftLeft') || k.has('ShiftRight'),
      crouch: k.has('ControlLeft') || k.has('ControlRight') || k.has('KeyC'),
      mouseDX: this.mouseDX, mouseDY: this.mouseDY,
      togglePerspective: k.has('KeyV'),
      togglePause: k.has('Escape'),
    };
    this.mouseDX = 0; this.mouseDY = 0;
    return out;
  }
}
